// extracted by mini-css-extract-plugin
export default {"messengerIconContainer":"MessengerButton_messengerIconContainer__03rwy"};